var products = []; 
keyFound = false;

for (let key in customFields) {  
    if (key === 'subscribed_services') {  
        // console.log("key", customFields[key]);
        if (JSON.parse(customFields[key]).length === 0) {  
            keyFound = false;  
            break;  
        } 
        products = JSON.parse(customFields[key]);  
        keyFound = true;
    }  
    else{  
        continue;  
    }  
}  
  
document.addEventListener('DOMContentLoaded', function() {  
    var table = document.getElementById('order-history');  
    var tableBody = table.getElementsByTagName('tbody')[0];    
    var continueButtonDown = document.querySelector('.continue-button-down'); 
    var continueButtonUp = document.querySelector('.continue-button-up'); 
    if (keyFound) { 
        continueButtonDown.style.display = 'none';  
        continueButtonUp.style.display = 'block'; 
        continueButtonUp.style.marginTop = '0px';
    //   console.log("products", products);
       // Do not show the certain SKUs
    //    console.log("window.CC_FEE_SKU", window.CC_FEE_SKU);
        products = products.filter(p => p.product_code !== window.CC_FEE_SKU);
        // console.log("products", products);
        products.forEach(function(product) {      
            var row = tableBody.insertRow();
            row.setAttribute('role', 'row'); 
            var cell1 = row.insertCell(0);  
            // console.log("Product_code", product.product_code);      
            cell1.innerHTML = '<div style="display: flex; align-items: center;"><img src="' + baseURL + skuToImage[product.product_code] + '" width="96" height="72" alt="Service Image" class="cart-item__image"><span style="text-align:center;padding-left:20px;">' + product.title + '</span></div>';     
            cell1.style.width = "68%"; 
          
            var cell3 = row.insertCell(1);  
            var formattedPrice = '$' + parseFloat(product.unit_price).toFixed(2);  
            cell3.innerHTML = '<div style="padding-top: 20px;">' + formattedPrice + '</div>';     
            cell3.style.width = "32%";   
        });  
        var orderhistoryTable = document.querySelector('.order-history-table');
        orderhistoryTable.style.marginBottom = '100px';
    }  
    else {  
        continueButtonDown.style.display = 'block';  
        continueButtonUp.style.display = 'none';  
        var messageSubscriptionDiv = document.getElementById('messageSubscriptionDiv'); 
        table.style.display = 'none'; 
        messageSubscriptionDiv.innerHTML = 'No records exists';
    }

});  



